import Config from "../config";
import React from "react";
import {useGlobal} from "reactn";

const Picture = ({user = {}, room}) => {

    let brand = useGlobal('brand')[0];

    if(room && room.source === 'zalo_personal'){
        if(!room.isGroup){
            return <img className="picture" src={user?.avatar} alt="Avatar Room"/>;
        }
        else{
            const peoples = room?.people;

            return (
                <div className="avatar-group">
                    {(peoples && peoples?.length > 0) && peoples.map((people, index) => (
                        people?.avatar && (
                            <div key={index} className="avatar-group-item">
                                <div className="img-drop"><img src={people?.avatar} alt={people?.firstName}/></div>
                            </div>
                        )
                    ))}
                </div>
            )
        }
    }

    if(room && room.isGroup){
        return <img className="picture" src={room.room_avatar} alt="Avatar Room"/>;
    }

    let firstName = user.firstName || "User";
    if (room && room.shieldedID){
        return <img className="picture" src={`${Config.url || ''}/api/images/${room?.shieldedID}/256/${brand}`} alt="Avatar User"/>;        
    }
    else
        return <div className="img">{firstName.substr(0,1).toUpperCase()}</div>;
};

export default Picture;
